<!--

- Homepage

- Go Fish: Start playing a random archive.

- Nav toolbar.

- Top drawer, opened with More icon in nav.

- Fix all show and profile links

- Show Page
  - List of Broadcasts that link to router
  - Broadcast Pagination? Later.

- Responsive styling for audio toolbar.

- Show current file's Broadcast title if playing file.


Testing:

- Play audio, minimize app, then open again. Does audio keep playing? Does it keep current page, or does WebKit refresh?

- Should we keep the Creek audio state in local storage, in order to keep it looking the same when you open app again?

-->

<template>
  
  <div class="creek-audio-page-player">
    <!-- <div v-if="Audio.API == null || API == null || API.Broadcast == null" v-html="Creek.config.shows.router.loadingHTML"></div> -->
    <div v-if="Audio.API == null || API == null || API.Broadcast == null"><i class="fa fa-spinner fa-spin fa-2x"></i></div>
    <div class="creek-broadcast-inner" v-if="API.Broadcast">
      <div class="creek-header">
        <div class="creek-broadcast-info" v-if="Audio.API.Broadcast && Audio.API.Broadcast.id">
          <h1 v-html="Audio.API.Broadcast.attributes.title"></h1>
          <p><a class="creek-show-title" v-if="Audio.API.Show && Audio.API.Show.id" v-html="Audio.API.Show.attributes.title" :href="'#/'+Audio.API.Show.attributes.short_name"></a></p>
          <div v-html="Audio.API.Broadcast.attributes.text"></div>
        </div>
      <!--
        <div class="creek-image-container">
          <img v-if="Broadcast.relationships.image" :src="Broadcast.relationships.image.url_sm" /> 
          <img v-if="Broadcast.relationships.show.relationships.image" :src="Broadcast.relationships.image.url_sm" /> 
        </div>
      -->
        <div class="creek-audio-player" v-if="Audio.URL">
          <div class="creek-controls">
            <button class="creek-button-main" type="button" @click="Creek.audio.file.toggle(Audio.API)">
              <!-- <span class="creek-audio-button-icon"> -->
                <span class="fa-stack fa-lg">
                  <i v-if="CurrentAudio.playable === true" class="creek-audio-play-icon fa fa-play fa-stack-1x"></i><i v-if="CurrentAudio.playable === false && CurrentAudio.state != 'loading'" class="creek-audio-pause-icon fa fa-pause fa-stack-1x"></i><i v-if="CurrentAudio.state == 'loading'" class="creek-audio-loading-icon fa fa-circle-o-notch fa-stack-1x fa-spin"></i>
                  <!-- <i class="creek-audio-circle-icon fa fa-circle-o fa-stack-2x"></i> -->
                </span>
              <!-- </span> -->
            </button>
            <creek-audio-seek-bar :audio="Audio"></creek-audio-seek-bar>
          </div>
        </div>
        <div class="creek-audio-player-empty" v-if="!Audio.URL">
          There is no audio for this broadcast.
        </div>
        <creek-social-buttons :data-link="API.Broadcast.links.share"></creek-social-buttons>
      </div>
      
      <creek-playlist v-if="Audio && Audio.API.Broadcast && Audio.API.Broadcast.relationships.playlist" :broadcast="Audio.API.Broadcast"></creek-playlist>
    <!--
      <div class="creek-footer">
        <a href="#"><img src="https://cdn.creek.fm/res/audio-player/logo.png" /></a>
      </div>
    -->
    </div>
  </div>

</template>

<style lang="stylus">


</style>

<script type="text/javascript">

import CreekAudioSeekBar from './AudioSeekBar';
import CreekPlaylist from './Playlist';
import CreekSocialButtons from './SocialButtons';

export default {
  name: 'creek-audio-player',
  props: ['broadcast-id'],
  components: {
    'creek-audio-seek-bar': CreekAudioSeekBar,
    'creek-playlist': CreekPlaylist,
    'creek-social-buttons': CreekSocialButtons
  },
  data: function(){
    var data = {
      Audio: {
        title: null,
        URL: null,
        playable: true,
        state: null,
        type: "file",
        API: {
          Broadcast: null,
          Media: null,
          Show: null,
        },
      }
    }
    return data;
  },
  computed: {
    CurrentAudio() {
      if(this.Creek.audio.file.API.Media && this.Audio.API.Media && this.Creek.audio.file.API.Media.id == this.Audio.API.Media.id){
        return this.Creek.audio.file;
      }
      else {
        return this.Audio;
      }
    },
    API() {
      return this.CurrentAudio.API || null;
    }
  },
  methods: {
    // They're all inside the main Creek thing
  },
  created: function () {

    if(!this.initialBroadcast){

      var URL = this.Creek.config.content.baseURLForAPI 
        + "/api/v2/broadcasts/" 
        + this.broadcastId

      var _this = this;

      // console.log(URL);

      this.JSONP(URL, null, function(err, data) {

        var Broadcast = data.data || null;
        // var Broadcast = data.data[0] || null;

        console.log(Broadcast);
        console.log(Broadcast);
        console.log(Broadcast);
        console.log(data);

        if(!Broadcast){
          return;
        }

        _this.Audio.API.Broadcast = Broadcast;
        _this.Audio.API.Show = Broadcast.relationships.show;

        if(Broadcast.relationships.media){
          _this.Audio.API.Media = Broadcast.relationships.media[0];
          _this.Audio.URL = Broadcast.relationships.media[0].meta.url;
        }

      })

    }
    else{
      this.Audio.API.Broadcast = this.initialBroadcast;
    }
    
    return true;

  }
}
</script>
